import React from "react";
import { 
  CheckCircle2, GraduationCap, BookOpen, UserCheck 
} from "lucide-react";

export default function About() {
  return (
    <main className="pt-20">
      {/* HERO SECTION */}
      <section className="bg-[#131A26] py-24 md:py-32 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="text-5xl md:text-7xl font-black text-[#FFC107] mb-6">
            ALearn India
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Where students meet teachers around the world online.<br />
            Transform your life through education.
          </p>
        </div>
        {/* Slanted background effect from screenshot */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-white/5 transform skew-x-12 translate-x-1/2" />
      </section>

      {/* OUR VISION SECTION */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-extrabold text-[#0056b3] mb-8">Our Vision</h2>
              <p className="text-gray-600 mb-10 text-lg leading-relaxed">
                Every great career starts with a vision. We teach you how to bring it to life. We believe in walking the extra mile in delivering quality to exceed the customers' expectations, both expressed and implied.
              </p>
              <ul className="space-y-6">
                {[
                  { icon: "🎯", text: "Anticipate changes and respond proactively." },
                  { icon: "🤝", text: "Treat people with dignity and care." },
                  { icon: "✅", text: "Fair dealings & professional conduct." }
                ].map((item, i) => (
                  <li key={i} className="flex items-start">
                    <span className="text-2xl mr-4">{item.icon}</span>
                    <span className="text-gray-800 font-bold text-lg">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop" 
                alt="Our Vision" 
                className="rounded-[40px] shadow-2xl w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE ALEARN? SECTION */}
      <section className="py-24 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-black text-gray-900 mb-6">Why Choose ALEARN?</h2>
            <p className="mt-4 text-gray-500 max-w-3xl mx-auto text-lg leading-relaxed">
              In a Globalized world, where mobility is facilitated learning language is a wonderful benefit. 
              Acquiring a second language enables us to develop various mental abilities at all ages. 
              Learning a foreign language opens up deployment opportunities and nourishes the growth of opportunities where different pathways of human knowledge can be discovered.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { title: "Highly Skilled Trainers", text: "We always deliver our training with commitment, a solid reputation, & qualities that impress the learner.", icon: GraduationCap },
              { title: "Get the Job Ready!", text: "Get job-ready with affordable, career-aligned training programs taught by expert instructors.", icon: BookOpen },
              { title: "Personalized Learning", text: "Tailored strategies that fit your schedule and learning pace, ensuring you master the subject efficiently.", icon: UserCheck },
            ].map((feature, i) => (
              <div key={i} className="bg-white p-12 rounded-3xl shadow-sm text-center border border-gray-100 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-8">
                  <feature.icon className="w-8 h-8 text-blue-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-500 leading-relaxed">{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* A DEFINITION BOX SECTION */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#FFC107]/80 rounded-[40px] p-12 md:p-20 text-center shadow-xl border border-[#FFC107]">
            <h2 className="text-3xl font-black text-gray-900 mb-8 uppercase tracking-widest">A Definition</h2>
            <div className="space-y-4 text-xl md:text-2xl text-gray-800 font-medium leading-relaxed">
              <p>Mutual Support Personnel Enjoy and Have Fun.</p>
              <p>Professional Tutors, Flexible Time Work Sharing is Caring.</p>
              <p>People Team is Number One, good manners in ethics.</p>
              <p>Always On Target Task.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
